// extracted by mini-css-extract-plugin
module.exports = {"container":"_245t8eCp_k-m_dEKNB-jvt","icon":"_1W6HM9WYSBJBTmLzE345fa","title":"L2KfpZS9YPjhjKjSuSVB","text":"_1BuYIbH5662f1NKqUn_GW0","retryBtn":"_3EG2sF55BCYv5UuadyifVf"};